import { RunningProgram, HtmlNode, program, div, text, class_, input, attribute, button, onInput, onClick, a } from "../derw-packages/derw-lang/html/src/Html";

import * as List from "../derw-packages/derw-lang/stdlib/src/List";

import { split } from "../derw-packages/derw-lang/stdlib/src/String";

type Model = {
    currentGuess: string;
    word: string;
    guesses: string[];
}

function Model(args: { currentGuess: string, word: string, guesses: string[] }): Model {
    return {
        ...args,
    };
}

type Noop = {
    kind: "Noop";
};

function Noop(args: {}): Noop {
    return {
        kind: "Noop",
        ...args,
    };
}

type ChangeGuess = {
    kind: "ChangeGuess";
    value: string;
};

function ChangeGuess(args: { value: string }): ChangeGuess {
    return {
        kind: "ChangeGuess",
        ...args,
    };
}

type SubmitGuess = {
    kind: "SubmitGuess";
};

function SubmitGuess(args: {}): SubmitGuess {
    return {
        kind: "SubmitGuess",
        ...args,
    };
}

type Msg = Noop | ChangeGuess | SubmitGuess;

function isInWordHelper(guessedLetter: string, wordLetter: string, hasBeenSeen: boolean): boolean {
    if (hasBeenSeen) {
        return hasBeenSeen;
    } else {
        return wordLetter === guessedLetter;
    }
}

function isInWord(char: string, word: string): boolean {
    return List.foldl(function(x: any, y: any) {
        return isInWordHelper(char, x, y);
    }, false, split("", word));
}

function viewInTile(inner: HtmlNode<Msg>): HtmlNode<Msg> {
    return div([ ], [ class_("tile") ], [ inner ]);
}

function viewLetter(correctLetter: string, guessedLetter: string, wholeWord: string): HtmlNode<Msg> {
    const isInWholeWord: boolean = isInWord(guessedLetter, wholeWord);
    if (correctLetter === guessedLetter) {
        return viewInTile(div([ ], [ class_("correct-letter"), class_("letter") ], [ text(guessedLetter) ]));
    } else {
        if (isInWholeWord) {
            return viewInTile(div([ ], [ class_("incorrectly-placed-letter"), class_("letter") ], [ text(guessedLetter) ]));
        } else {
            return viewInTile(div([ ], [ class_("incorrect-letter"), class_("letter") ], [ text(guessedLetter) ]));
        };
    }
}

function viewRow(word: string, guess: string): HtmlNode<Msg> {
    return div([ ], [ class_("row") ], List.map(function(i: any) {
        return viewLetter(word[i], guess[i], word);
    }, Array.from({ length: 4 - 0 + 1 }, (x, i) => i + 0)));
}

const viewEmptyLetter: HtmlNode<Msg> = viewInTile(div([ ], [ class_("letter"), class_("empty-letter") ], [ ]));

const viewEmptyRow: HtmlNode<Msg> = div([ ], [ class_("row") ], List.map(function(_: any) {
    return viewEmptyLetter;
}, Array.from({ length: 4 - 0 + 1 }, (x, i) => i + 0)));

function viewGuessInput(word: string): HtmlNode<Msg> {
    return input([ onInput(function(word: any) {
        return ChangeGuess({ value: word });
    }) ], [ attribute("value", word), attribute("type", "text") ]);
}

function viewSubmit(currentGuess: string): HtmlNode<Msg> {
    if (currentGuess.length < 5) {
        return text("");
    } else {
        return button([ onClick(function(_: any) {
            return SubmitGuess({ });
        }) ], [ class_("submit") ], [ text("Submit guess") ]);
    }
}

function viewGame(model: Model): HtmlNode<Msg> {
    const rows: HtmlNode<Msg>[] = List.map(function(guess: any) {
        return viewRow(model.word, guess);
    }, model.guesses);
    const remainingRowsToMake: number = 5 - model.guesses.length;
    const emptyRows: HtmlNode<Msg>[] = List.map(function(_: any) {
        return viewEmptyRow;
    }, Array.from({ length: remainingRowsToMake - 1 + 1 }, (x, i) => i + 1));
    const joinedRows: HtmlNode<Msg>[] = List.append(rows, emptyRows);
    return div([ ], [ class_("game") ], [ a([ ], [ attribute("href", "https://www.powerlanguage.co.uk/wordle/") ], [ text("Wordle, but in Derw") ]), a([ ], [ attribute("href", "https://github.com/derw-lang/wordle") ], [ text("Click here to check out the source") ]), text("We have hidden a 5 letter word below"), div([ ], [ class_("board") ], joinedRows), div([ ], [ class_("guess-input") ], [ text("Enter your guess:"), viewGuessInput(model.currentGuess), viewSubmit(model.currentGuess) ]) ]);
}

function view(model: Model): HtmlNode<Msg> {
    return div([ ], [ ], [ viewGame(model) ]);
}

function update(msg: Msg, model: Model): Model {
    const _res = msg;
    switch (_res.kind) {
        case "Noop": {
            return model;
        }
        case "ChangeGuess": {
            const { value } = _res;
            return {
            word: model.word,
            guesses: model.guesses,
            currentGuess: value
        };
        }
        case "SubmitGuess": {
            return {
            word: model.word,
            guesses: List.append(model.guesses, [ model.currentGuess ]),
            currentGuess: ""
        };
        }
    }
}

const initialModel: Model = {
    word: "hello",
    guesses: [ ],
    currentGuess: ""
};

const root: any = document.getElementById("root");

const main: RunningProgram<Model, Msg> = program({
    initialModel,
    view,
    update,
    root
});
